export enum NavSection {
  RD_TAX_CREDIT = 'R&D TAX CREDIT',
  ASC_350_40 = 'ASC 350-40',
}
